/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

document.addEventListener("DOMContentLoaded", function () {
    const showSubMenu = document.getElementById("showSubMenu");
    const btnClose    = document.getElementById("btnClose");
    const subMenu     = document.getElementById("subMenu");
    const bgBeige     = document.querySelector(".bg-beige");

    showSubMenu.addEventListener("click", function () {
        const isActive = subMenu.classList.contains("active");
        subMenu.classList.toggle("active", !isActive);
        showSubMenu.classList.toggle("active", !isActive);

        if (isActive) {
            bgBeige.style.backgroundColor = "";
            btnClose.style.display = "none";
        } else {
            bgBeige.style.backgroundColor = "#F3F0EA";
            btnClose.style.display = "block";
        }
    });

    btnClose.addEventListener("click", function () {
        subMenu.classList.remove("active");
        showSubMenu.classList.remove("active");
        bgBeige.style.backgroundColor = "";
        btnClose.style.display = "none";
    });
});
